<div id="map" class="map"></div>

<div class="bottom-sheet-div" *ngIf="showSearchCoordinates">
    <div class="search-coordinates" *ngIf="showSearchCoordinates">
        <div class="container pb-3">
            <div class="row">
                <div class="col-auto font-weight-bold" l10nTranslate>map.controls.searchCoordinates.title</div>
                <div class="col-auto pointer" l10n-title title="map.controls.searchCoordinates.close" l10nTranslate (click)="showSearchCoordinates = false;"><i class="far fa-times-circle"></i></div>
            </div>
        </div>
        <form class="pb-3" [formGroup]="searchCoordinatesForm">
            <div class="form-group row">
              <label for="inputEmail3" class="col-sm-3 col-form-label" l10nTranslate>map.controls.searchCoordinates.longitude</label>
              <div class="col-sm-9">
                <input class="form-control" type="number" step="any" lang="en" id="longitude" name="longitude" formControlName="longitude">
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword3" class="col-sm-3 col-form-label" l10nTranslate>map.controls.searchCoordinates.latitude</label>
              <div class="col-sm-9">
                <input class="form-control" type="number" step="any" lang="en" id="latitude" name="latitude" formControlName="latitude">
              </div>
            </div>
        </form>
        <div class="container">
            <div class="row">
                <button type="button" class="btn btn-secondary btn-lg btn-block" (click)="searchCoordinates();" l10nTranslate>map.controls.searchCoordinates.go</button>
            </div>
        </div>
    </div>
</div>